module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/billbo-desktop-v2/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main